import {OrderService, MovieService, RegionService,MovieMetaService} from 'hasta-la-vista-middleware-api/service'

export default {

    props: {
        order: Object,
        session: Object,
        cinema: Object,
        activeOrder: Boolean,
        index: null,
    },

    data(){
        return {
            movie: {},
            expanded: false,
            seeBtn: 'See more',
            toggleDeleteDialog: false,
            deleteId: null,
            showWarning: false,
            loading: false,
            loadingDelete: false,
            currency: "R"
        }
    },

    methods: {
        promtDelete(deleteId) {
            this.toggleDeleteDialog = true
            this.deleteId = deleteId
        },

        cancelDelete() {
            this.toggleDeleteDialog = false;

            this.deleteId = null
        },

        confirmDelete() {
            this.loadingDelete = true
            this.toggleDeleteDialog = false

            OrderService.removeSession(this.session.SessionId).then(
                (cancelled) => {
                    this.loadingDelete = false
                    this.$emit('closeDialog')
                }
            )
        },

        setBasketItem(){
            OrderService.setPendingSession(this.session.SessionId, this.session.CinemaId, this.movie.id)
                if (!this.order.Session.SeatGridPromise)
                    this.order.Session.getSeatGrid();
                setTimeout(()=> {
                    this.order._loading = false
                    if(this.$route.path != '/booking/1') {
                        this.$router.push({path: '/booking/1'})
                    }
                }, 100) // this is done to allow the seatgrid svg to remount the dom.


        },

        editBasketItem(index) {
            if (this.order.Session.Tickets.length == 0) return this.showWarning = true;
            this.order._loading = true;
            this.$emit('closeDialog')
            if (this.order.modified) {
                this.loading = true;
                OrderService.saveTickets().then((order)=> {
                    this.order.setOrder(order);
                    this.loading = false;
                    this.setBasketItem();
                }, ()=>this.loading = false)
            } else {
                this.setBasketItem();
                
            }

        },

        expandTickets() {
            if (this.expanded) {
                this.seeBtn = 'See more'
                this.expanded = false
            }
            else {
                this.seeBtn = 'See less'
                this.expanded = true
            }
        }
    },

    created(){
        Promise.resolve(MovieMetaService.getMovieMeta()).then((meta) => {

            if(meta.extended_regions_data != undefined) {
                for(let i = 0; i < meta.extended_regions_data.length; i++) {
                    if(meta.extended_regions_data[i] != undefined) {
                        if(meta.extended_regions_data[i].cinema_id == this.order.CinemaId) {
                            this.currency = meta.extended_regions_data[i].currency_symbol
                        }
                    }
                }
            }
        })
    },

    computed: {
        ticketsGrouped() {

            // if (!this.session || !this.session.Tickets) {
            //     return []
            // }

            // var tickets = this.session.Tickets.reduce((collection, ticket)=> {
            //     let key = ticket.Description;
            //     collection[key] = collection[key] || {
            //             Description: ticket.Description,
            //             PriceInCents: 0,
            //             Quantity: 0
            //         };
            //     collection[key].PriceInCents += ticket.PriceCents || ticket.PriceInCents;
            //     collection[key].Quantity++;
            //     return collection;
            // }, {});

            // console.log(tickets)

            // return tickets;
        },

        classes() {
            return {
                'ticket-component-ticket': true,
                'ticket-component-ticket--active': this.expanded
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/performance/performance-info/performance-info.js